export default "__VITE_ASSET__liH3$n3T__"